import React from 'react';
import { Chip } from '@mui/material';
import { categoryPalette } from '../../theme/tokens';

/**
 * Category badge.
 *
 * Uses a tinted background plus a matching text colour and a leading dot, so
 * category is conveyed by position and label as well as hue rather than by
 * colour alone.
 */
const CategoryChip = ({ category, size = 'small', variant = 'soft' }) => {
  // 'Unattributed' is the current residual label; 'Uncategorized' is retired.
  const key = category || 'Unattributed';
  const token = categoryPalette[key] || categoryPalette.Other;

  return (
    <Chip
      size={size}
      label={key}
      sx={{
        color: variant === 'soft' ? token.text || token.main : '#fff',
        backgroundColor: variant === 'soft' ? token.soft : token.main,
        border: '1px solid',
        borderColor: variant === 'soft' ? token.soft : token.main,
        fontWeight: 600,
        '& .MuiChip-label': { px: 1, display: 'flex', alignItems: 'center', gap: 0.75 },
        '&::before': {
          content: '""',
          display: 'block',
          width: 6,
          height: 6,
          borderRadius: '50%',
          backgroundColor: token.main,
          marginLeft: '8px',
          flexShrink: 0,
        },
      }}
    />
  );
};

export default CategoryChip;
